// extracted by mini-css-extract-plugin
export var active = "_td-1";
export var circle = "_td-0";
export var completed = "_td-2";
export var connector = "_td-4";
export var connectorCompleted = "_td-7";
export var connectorSpacer = "_td-5";
export var iconStrokeOverride = "_td-8";
export var labelContainer = "_td-6";
export var pending = "_td-3";